import { useMemo } from 'react';
import { Table } from '@/components';
import { useGetScheduledPending, usePreparePackagePagination } from '../hooks';
import { preparePackageTableColumns } from '../config';
import { PreparePackageActions } from './PreparePackageActions';
import { PreparePackageFilter } from '../models';

interface PreparePackageTableProps {
  filter: Partial<PreparePackageFilter>;
}

const PreparePackageTable = ({ filter }: PreparePackageTableProps) => {
  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    usePreparePackagePagination();

  const { schedulePending, totalItems, totalPages, isLoading } =
    useGetScheduledPending({
      paginated: { page: currentPage, pageSize },
      filters: filter,
    });

  const columns = useMemo(() => preparePackageTableColumns, []);

  const renderActions = (rowData: Record<string, any>) => (
    <PreparePackageActions rowData={rowData} />
  );

  return (
    <div className='w-full p-5 flex flex-col bg-white rounded-lg shadow-md gap-5'>
      <Table
        columns={columns}
        data={schedulePending}
        isLoading={isLoading}
        renderActions={renderActions}
        pagination={{
          totalItems,
          totalPages,
          currentPage,
          rowsPerPage: pageSize,
          onPageChange: handlePageChange,
          onRowsPerPageChange: handlePageSizeChange,
        }}
      />
    </div>
  );
};

export default PreparePackageTable;
